import * as React from 'react';

export type StepDirection = -1 | 0 | 1;

/** The direction of the most recent change to `value`, as ordered by `compare`; 0 until it first changes. */
export function useStepDirection<TValue>(
  value: TValue,
  compare: (next: TValue, previous: TValue) => number,
): StepDirection {
  const [previous, setPrevious] = React.useState(value);
  const [direction, setDirection] = React.useState<StepDirection>(0);
  const order = compare(value, previous);
  if (order !== 0) {
    setPrevious(value);
    setDirection(order > 0 ? 1 : -1);
  }
  return direction;
}
